/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export interface IBookOfShadowsSymbolStates extends ISymbolStates {
    noWin: ISymbolStateConfig;
    idle: ISymbolStateConfig;
    land: ISymbolStateConfig;
    goldNormal: ISymbolStateConfig;
    goldSpin: ISymbolStateConfig;
    goldLand: ISymbolStateConfig;
    goldWin: ISymbolStateConfig;
    winToggle: ISymbolStateConfig;
    sAnticipation: ISymbolStateConfig;
}

export class BookOfShadowsReelSymbol extends StateReelSymbol {

    /**
     * @constructs
     * @param symName
     * @param reelId
     * @param state
     */
    constructor(symName: string, reelId: number, state?: ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    /**
     * @inheritDoc
     * @override To implement spine as State in some of the symbols.
     * @param timeline
     * @param newState
     * @param stateAnimation
     * @param delay
     */
    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        const symName: string = this.symName,
            spineStates: string[] = ["Win", "Idle", "Land", "Gold_Land", "Gold_Win", "WinToggle", "Anticipation"],
            stateKey: string = newState.state.keyword;

        let loopCount: number = 0;

        if (spineStates.indexOf(stateKey) !== -1) {
            let separator: string = (stateKey === "Gold_Land" || stateKey === "Gold_Win") ? "" : "_"; // #22

            if ((stateKey === spineStates[1] || stateKey === spineStates[6]) && (symName === "S")) {
                loopCount = -1;
            }

            timeline.add(new SpineTween((stateAnimation as any), 0, symName + separator + stateKey, loopCount), delay);
            if (stateKey === spineStates[0] || stateKey === spineStates[5] || stateKey === spineStates[6]) {
                timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay);
            } else {
                stateAnimation.alpha = 1;
            }

            return;
        }

        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
    }
}